import base from "/app/images/atmos.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");